import { NgModule } from '@angular/core';
import {
  ActivationPricingServiceInterfaceToken,
  ActivationServiceInterfaceToken,
} from '../../common/app-selection/paginated-app-activation-table/tokens';
import { VbcHostService } from '../../vbc/vbc.host.service';
import { getHostName } from '../activation.module';
import { ActivateAppApiService } from '../core/activate-app/activate-app-api.service';
import { ActivateAppService } from '../core/activate-app/activate-app.service';
import { ActivationParamService } from '../core/activation-param.service';
import { ActivationPricingService } from '../core/activation-pricing.service';
import { ActivationService } from '../core/activation.service';
import { ActivationAnalyticsService } from '../core/analytics/activation-analytics.service';
import { VBC_HOST } from '../core/injection-tokens';

@NgModule({
  imports: [],
  exports: [],
  providers: [
    ActivationService,
    { provide: ActivationServiceInterfaceToken, useExisting: ActivationService },
    ActivateAppService,
    ActivationPricingService,
    { provide: ActivationPricingServiceInterfaceToken, useExisting: ActivationPricingService },
    ActivationParamService,
    { provide: VBC_HOST, deps: [VbcHostService], useFactory: getHostName },
    ActivateAppApiService,
    ActivationAnalyticsService,
    VbcHostService,
  ],
})
export class SharedActivationModule {}
